<template>
  <a-modal
    :title="form.categorize_id ? '修改分类信息' : '新增分类信息'"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    destroyOnClose
    :maskClosable="false"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="所属供应商" prop="supplier_id">
        <a-select v-model="form.supplier_id" placeholder="请选择" disabled>
          <a-select-option
            :value="v.supplier_id"
            v-for="v in supplierList"
            :key="v.supplier_id"
          >
            {{ v.supplier_name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="分类名称" prop="categorize_name">
        <a-input
          v-model="form.categorize_name"
          placeholder="请输入项目的分类名称"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { baseURL } from "@/api/index";
import { mapState } from "vuex";
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  computed: {
    ...mapState(["token"]),
  },
  data() {
    return {
      baseURL,
      visible: false,
      confirmLoading: false,
      loading: false,
      fileList: [],
      form: {
        categorize_id: "",
        supplier_id: undefined,
        categorize_name: "",
      },
      treeData: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        categorize_name: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        supplier_id: [
          {
            required: true,
            message: "请选择供应商",
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      supplierList: [],
    };
  },
  methods: {
    init(id, supplier_id) {
      this.visible = true;
      this.form.categorize_id = id;
      this.form.supplier_id = supplier_id
      this.getSupplierList();
      if (id) {
        this.$http({
          url: "/admin/suppliercategorize/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = { ...res.data };
        });
      }
    },
    getSupplierList() {
      this.$http({
        url: "/admin/supplier/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.supplierList = res.data.result;
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: this.form.categorize_id
              ? "/admin/suppliercategorize/update"
              : "/admin/suppliercategorize/create",
            method: "post",
            data: this.form,
          })
            .then(() => {
              this.$message.success(
                this.form.categorize_id ? "修改成功" : "创建成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
    remove(e) {
      this.form.department_logo = "";
    },
    handleChange(info) {
      // let fileList = [...info.fileList];
      // fileList = fileList.slice(-1);
      // fileList = fileList.map((file) => {
      //   if (file.response) {
      //     file.url = file.response.data.url;
      //     this.form.department_logo = file.response.data.url;
      //   }
      //   return file;
      // });
      // this.fileList = fileList;
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        // Get this url from response in real world.
        // getBase64(info.file.originFileObj, (imageUrl) => {
        //   this.form.goods_img = imageUrl;
        //   this.loading = false;
        // });
        this.loading = false;
        this.form.goods_img = info.file.response.data.url;
      }
    },
    preview(e) {
      this.$viewerApi({
        images: [e.response.url],
      });
    },
  },
};
</script>

<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>